import { useEffect, useState } from 'react';
import { ReCaptchaProvider } from 'react-grecaptcha-v3';


const BizzoModule = () => {
  const [BizzoApp, setBizzoApp] = useState(null);

  useEffect(() => {
    import('bizzo/Module').then((mod) => {
      setBizzoApp(() => mod.default);
    })
  }, []);
  return (
    <ReCaptchaProvider
      siteKey={window?.PlatformSetup?.RECAPTCHA_SITE_KEY}
      injectionDelay={12000}
    >
      {BizzoApp ? <BizzoApp /> : null}
    </ReCaptchaProvider>
  );
};

export default BizzoModule;
